import styled from "styled-components"

export const Container = styled.div`
    width: 100%;
    height: fit-content;
    text-align: center;
    position: relative;
    bottom: 0;
    padding: 20px;
    background: #2E2E2E;
`

export const Wrap = styled.div`
    width: 100%;
    height: 100%;
`

export const Logo = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;
     
     img{
         width: 280px;
     }
`

export const Endereco = styled.div`
    width: 100%;
    height: 100%;
    color: #fff;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

`